import { Assets } from '@timeflies/static-assets';
import React from 'react';
import { getNextMusic, useMusicContext, useMusicCurrentContext, useMusicCurrentDispatch, useMusicVolumeContext } from '../view/music-context';
export var useMusic = function () {
    var musicContext = useMusicContext();
    var currentMusic = useMusicCurrentContext();
    var dispatchCurrentMusic = useMusicCurrentDispatch();
    var musicVolume = useMusicVolumeContext();
    var fnRef = React.useRef();
    fnRef.current = function (musicKey) {
        if (!musicContext || musicKey === (currentMusic === null || currentMusic === void 0 ? void 0 : currentMusic.currentKey)) {
            return;
        }
        var prevMusic = currentMusic && musicContext[currentMusic.currentKey][currentMusic.index];
        var _a = getNextMusic(musicContext, currentMusic, musicKey, Assets.musics), nextIndex = _a.nextIndex, nextMusic = _a.nextAudio;
        if (prevMusic) {
            prevMusic.fade(musicVolume, 0, 1000);
            prevMusic.once('fade', function () {
                prevMusic.pause();
            });
        }
        nextMusic.volume(musicVolume);
        nextMusic.play();
        nextMusic.fade(0, musicVolume, 1000);
        dispatchCurrentMusic({ currentKey: musicKey, index: nextIndex });
    };
    // avoid unecessary music playing (causing infinite loop)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return React.useCallback(function (musicKey) { return fnRef.current(musicKey); }, [fnRef, musicContext]);
};
export var usePlayMusic = function (musicKey) {
    var playMusic = useMusic();
    React.useEffect(function () {
        playMusic(musicKey);
    }, [playMusic, musicKey]);
};
